import * as React from 'react';
export const hypotirolSvg = React.forwardRef(function hypotirolSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1A3374',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M24.73 2.9h4.36v4.37h-4.36V2.91zM23.27 16h-4.36V7.27h-4.36V2.91h8.72V16z',
      }),
    ),
  );
});
hypotirolSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var hypotirol = {
  category: 'brand',
  colorable: false,
  name: 'hypotirol',
  svg: hypotirolSvg,
};
